import { useEffect, type ReactNode } from "react";
import { I18nProvider } from "@lingui/react";
import { activateLocale, i18n } from "./i18n";
import { useLocalePreference } from "./locale-preference";

/**
 * 언어 선호값(localStorage)을 구독해 lingui 인스턴스에 반영하는 Provider.
 * 라우터 진입 전에 렌더링되는 페이지(로그인/온보딩)도 커버하도록 앱 최상위
 * (main.tsx)에서 전체를 감싼다.
 */
export function AppI18nProvider({ children }: { children: ReactNode }) {
  const locale = useLocalePreference();

  useEffect(() => {
    activateLocale(locale);
  }, [locale]);

  return <I18nProvider i18n={i18n}>{children}</I18nProvider>;
}
